import { GlobalStore } from '@highlight/ipc'
import GlobalStateUtils from '@shared/ipc/GlobalStateUtils.ts'
import { TELEMETRY_VERSION } from '@shared/config/Config.ts'
import { getAmplitudeDeviceId, getDeviceUUID } from '@shared/store/impl/device.ts'

export const getTelemetryVersion = () => {
  const storedTelemetryVersion = GlobalStore.user().get<number>('telemetryVersion')
  if (storedTelemetryVersion !== undefined) {
    return storedTelemetryVersion
  }

  // Default to the version set by the client
  let defaultVersion = TELEMETRY_VERSION

  // For users who installed before the v2 telemetry date, default them to v1
  const installedAt = GlobalStore.general().get<number>('installedAt')
  if (installedAt !== undefined) {
    const installedBeforeV2 = installedAt < 1745366400000 // 4/23/2025
    if (installedBeforeV2) {
      console.log('Defaulted to v1 telemetry version for old install')
      defaultVersion = 1
    }
  }

  // Store the telemetry version forever for this user
  console.log('Setting telemetry version:', defaultVersion)
  GlobalStore.user().set<number>('telemetryVersion', defaultVersion)
  return defaultVersion
}

export const getUserIdentity = () => {
  const userIdentity: { deviceId: string; userId: undefined | string } = {
    deviceId: '',
    userId: undefined,
  }

  const user = GlobalStateUtils.user.get()
  const isAnonymous = !user || user.isAnonymous
  const telemetryVersion = getTelemetryVersion()

  if (telemetryVersion === 1) {
    // v1 telemetry will always use supabase or workos id as userId
    const clientAnonymousId = GlobalStore.user().get<string>('amplitudeDeviceId') ?? getDeviceUUID('v1')
    if (!clientAnonymousId) {
      throw new Error('Missing clientAnonymousId')
    }
    userIdentity.deviceId = clientAnonymousId
    userIdentity.userId = user?.id
  } else if (telemetryVersion === 2) {
    // v2 telemetry will use deviceId for anonymous user ID, and will use userId for logged in user ID
    const amplitudeDeviceId = getAmplitudeDeviceId()
    const deviceId = getDeviceUUID('v2')

    // Prefer the amplitudeDeviceId via web attribution, fallback to deviceId generated by client.
    const preferredDeviceId = amplitudeDeviceId ?? deviceId
    if (!preferredDeviceId) {
      throw new Error('Missing both deviceId and amplitudeDeviceId')
    }

    userIdentity.deviceId = preferredDeviceId
    userIdentity.userId = isAnonymous ? undefined : user?.id
  }
  return userIdentity
}
